/**
 * Servicio para comunicación con el backend
 */

import axios from "axios";
import api from "../../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY || '';
/**
 * Guarda o actualiza una landing page
 * @param {FormData} formData - Datos del formulario
 * @param {boolean} esEdicion - Indica si es edición o creación
 * @param {number} id - ID de la landing (solo para edición)
 * @returns {Promise}
 */
export const guardarLandingPage = async (formData, esEdicion = false, id = null) => {
    try {
        const url = esEdicion
            ? `${urlApi}/comercial/landing-page`
            : `${urlApi}/comercial/landing-page`;

        const method = esEdicion ? 'PUT' : 'POST';
        if (method === 'PUT') {
            const response = await api.put(url, formData);
            return response.data;
        }
        else {
            const response = await api.post(url, formData);
            return response.data;
        }
    } catch (error) {
        console.error('Error al guardar landing:', error);
        throw error;
    }
};

/**
 * Obtiene todas las landing pages
 * @returns {Promise<Array>}
 */
export const obtenerLandings = async () => {
    try {
        const response = await api.get(`${urlApi}/comercial/landing-page`);
        return response.data;
    } catch (error) {
        console.error('Error al obtener landings:', error);
        throw error;
    }
};

/**
 * Obtiene una landing page por ID
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const obtenerLandingPorId = async (id) => {
    try {
        const response = await api.get(`${urlApi}/comercial/landing-page/${id}`);

        return response.data;   
    } catch (error) {
        console.error('Error al obtener landing:', error);
        throw error;
    }
};

/**
 * Elimina una landing page
 * @param {number} id
 * @returns {Promise}
 */
export const eliminarLanding = async (id) => {
    try {
        const response = await fetch(`/api/landing/${id}`, {
            method: 'DELETE'
        });

        if (!response.ok) {
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error al eliminar landing:', error);
        throw error;
    }
};
